import { useEffect, useState } from 'react'
import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import HomeSectionsRenderer from '@/components/HomeSectionsRenderer'
import { faqs } from '@/data/content'
import { useHomeSections } from '@/hooks/useHomeSections'

export default function Home() {
  const topFaqs = faqs.slice(0, 4)

  // CRITIQUE: ne rendre les sections qu'après hydratation client.
  // Sinon le HTML pré-rendu (vite-prerender-plugin) fige un état des sections
  // au moment du build, qui peut diverger de la base actuelle (problème mobile
  // observé: 9 sections natives masquées en base mais encore visibles dans le
  // HTML statique servi sur mobile, jusqu'à ce que React s'hydrate).
  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])

  // Toutes les sections (natives + custom) pilotées depuis /admin
  const { items: homeSections } = useHomeSections()
  const orderedSections = (homeSections || [])
    .filter((s) => s?.isActive)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': 'https://bnssa-mns.fr/#website',
        url: 'https://bnssa-mns.fr/',
        name: 'Emplois BNSSA & MNS',
        description:
          'Plateforme spécialisée dans le recrutement des BNSSA et Maîtres Nageurs Sauveteurs en France.',
        inLanguage: 'fr-FR',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: 'https://bnssa-mns.fr/offre-emploi?q={search_term_string}',
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        '@id': 'https://bnssa-mns.fr/#organization',
        url: 'https://bnssa-mns.fr/',
        name: 'Emplois BNSSA & MNS',
        logo: 'https://bnssa-mns.fr/logo.png',
        sameAs: [],
      },
      {
        '@type': 'FAQPage',
        url: 'https://bnssa-mns.fr/',
        mainEntity: topFaqs.map((f) => ({
          '@type': 'Question',
          name: f.question,
          acceptedAnswer: { '@type': 'Answer', text: f.answer },
        })),
      },
    ],
  }

  return (
    <Layout>
      <Seo
        title="Emploi BNSSA & MNS — Offres & Formations | bnssa-mns.fr"
        description="Plateforme spécialisée dans le recrutement des BNSSA et Maîtres Nageurs Sauveteurs en France. CDI, CDD, intérim, auto-entrepreneur. Formations BPJEPS et BNSSA."
        canonical="https://bnssa-mns.fr/"
        jsonLd={websiteJsonLd}
      />

      {isClient && <HomeSectionsRenderer sections={orderedSections} />}
    </Layout>
  )
}
